// 请求 状态code
export enum requestCode {
  RESULT_CODE_SUCCESS_0 = 0, // 业务成功（部分接口返回0）
  RESULT_CODE_SUCCESS_200 = 200, // 业务成功（部分接口返回200）
  RESULT_CODE_SUCCESS_401 = 401, // Token 过期
  RESULT_CODE_BAD_REQUEST = 412, // 请求错误
  RESULT_CODE_NOT_LOGIN = 402, // 未登录
  RESULT_CODE_PARAM_ERROR = 406, // 传参错误
  RESULT_CODE_SERVER_ERROR = 500, // 服务器错误
  RESULT_CODE_NOON_EXPIRED = 10010, // Noon 登录过期
}
